import React from 'react';
import { formatPhoneNumber } from "../../helpers/formatting";
import { getDirectionsUrl } from "../../helpers/location";
import OperationHours from './OperationHours';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class PickupLocation extends React.Component {
    constructor(props, params) {
        super(props, params);
        this.state = { directionsUrl: getDirectionsUrl(null, props.pharmacy.Address), showMoreHours: false };
        this.redirectToMap = this.redirectToMap.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PickupLocation.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    redirectToMap() {
        if (typeof window !== 'undefined' && this.state.directionsUrl) {
            window.open(this.state.directionsUrl, "_blank");
        }
    }

    render() {
        const { containerClass, pharmacy, showOperationHours } = this.props;
        const phoneNumber = pharmacy && pharmacy.PhoneNumber ? formatPhoneNumber(pharmacy.PhoneNumber) : "";
        const address = pharmacy && pharmacy.Address ? pharmacy.Address : null;
        return (
            <div className={containerClass}>
                <h4 className="h5 main">Pickup Location:</h4>
                {!pharmacy || !pharmacy.Name ? '-' :
                    <React.Fragment>
                        <a className="directions-link" href={this.state.directionsUrl} target="_blank">
                            <div className="pharmacy-tile__address details-icon-prepend">
                                <div className="icon-col">
                                    <span className="icon-address" />
                                </div>
                                <div className="details-col">
                                    <div>{pharmacy.Name}</div>
                                    {address && (address.StreetAddress + ', ' + address.City + ', ' + address.State + ' ' + address.Zip)}
                                </div>
                            </div>
                        </a>
                        <a className="phone-link" href={"tel:" + phoneNumber}>
                            <div className="pharmacy-tile__phone details-icon-prepend">
                                <div className="icon-col">
                                    <span className="icon-phone" />
                                </div>
                                <div className="details-col">
                                    {phoneNumber}
                                </div>
                            </div>
                        </a>
                        <OperationHours pharmacy={pharmacy} />   
                    </React.Fragment>
                }
            </div>
        );
    }
}